import { render, staticRenderFns } from "./mini-img-ad.vue?vue&type=template&id=533e8af4&scoped=true&"
import script from "./mini-img-ad.vue?vue&type=script&lang=ts&"
export * from "./mini-img-ad.vue?vue&type=script&lang=ts&"
import style0 from "./mini-img-ad.vue?vue&type=style&index=0&id=533e8af4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533e8af4",
  null
  
)

export default component.exports